// @flow

import React, { type Node } from 'react';
import { PaymentInfo } from './payment-info';
import { usePendingIncomingPayment, getCountry} from '@tectonics/prs/incoming-payment';
import { formatUberPixExpirationDatetime } from '@tectonics/prs/voucher';
import { getExpirationOrDueDatetime } from '@tectonics/prs/incoming-payment/get-expiration-or-due-datetime';

export function DisplayExpiration(): Node {
  const expirationDatetime = ExpirationDatetime();
  const paymentLabel = expirationDatetime ? 'Pague até:' : '';

  return (
    <PaymentInfo label={paymentLabel} >
      { expirationDatetime }
    </PaymentInfo>
  );
}

function ExpirationDatetime(): string {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);
  const dateTobeFormatted : string = getExpirationOrDueDatetime(incomingPayment);
  const formattedDateToBeReturned : string = formatUberPixExpirationDatetime(dateTobeFormatted);

  switch (country) {
    case 'br':
      return formattedDateToBeReturned;

    default:
      throw new Error(`Voucher Ticket Due Date Title - Not implemented for country "${country}" yet`);
  }
}
